export const HAND_CHOICES = [2, 4];
export const HAND_CHOICES_NAMES = ['One Therapist', 'Two Therapists'];
export const CC_YEAR_START = 2015;
export const CLASS_BOOKING_ROUTE = 'class-booking';
export const GROUP_QUERY_CLASS = 'class';
export const GROUP_QUERY_TRAINER = 'trainer';

export const NEW_USER_EXIT_PROMO_POPUP_COOKIE_NAME = 'new_user_exit_promo_popup_dismissed';

// BOOKING FLOW SCREENS
export const SCREEN_ADDRESS = 'address';
export const SCREEN_ADD_TREATMENT_CATEGORY = 'add-treatment-category';
export const SCREEN_ADD_TREATMENT_TREATMENTS = 'add-treatment-treatments';
export const SCREEN_B2B_REDIRECT = 'b2b-redirect';
export const SCREEN_CLASS = 'worker-class';
export const SCREEN_CLASS_ACCOUNT = 'class-account';
export const SCREEN_VERTICAL = 'vertical';
export const SCREEN_TYPE_DURATION = 'type-duration';
export const SCREEN_TYPE_DURATION_2 = 'type-duration2';
export const SCREEN_LOADING = 'loading';
export const SCREEN_TREATMENT = 'treatment';
export const SCREEN_TREATMENT_2 = 'treatment2';
export const SCREEN_SLOT = 'therapist/slot';
export const SCREEN_ACCOUNT = 'account';
export const SCREEN_CHECKOUT = 'checkout';

export const EMPTY_CONTENT_REGEX = /(\r\n|\n|\r)/gm;

export const APPOINTMENT_TYPE = {
  ONE_ON_ONE: 'one-on-one',
  CLASSES: 'classes',
};



// WEBPACK FOOTER //
// ./utils/constants.jsx